import { BONDS_SUBGRAPH_URL } from '@sushiswap/bonds-sdk';
import { addChainId } from '../../../lib/modifiers/add-chain-id';
import { convertIdToMultichainId } from '../../../lib/modifiers/convert-id-to-multichain-id';
import { copyIdToAddress } from '../../../lib/modifiers/copy-id-to-address';
import { requestPaged } from '../../../lib/request-paged';
import { graphql } from '../graphql';
export const BondMarketsQuery = graphql(`
  query Markets($first: Int = 1000, $skip: Int = 0, $block: Block_height, $orderBy: Market_orderBy, $orderDirection: OrderDirection, $where: Market_filter) {
    markets(first: $first, skip: $skip, block: $block, orderBy: $orderBy, orderDirection: $orderDirection, where: $where) {
      id
      chainId
      type
      auctioneer
      teller
      marketId
      owner
      capacity
      capacityInQuote
      minPrice
      scale
      start
      conclusion
      payoutToken {
        id: address
        symbol
        decimals
        name
      }
      quoteToken {
        id: address
        symbol
        decimals
        name
      }
      vesting
      vestingType
      isInstantSwap
      hasClosed
      totalBondedAmount
      totalPayoutAmount
      averageBondPrice
      bondsIssued
    }
  }
`);
export async function getBondMarkets({ chainId, ...variables }, options) {
    const url = `https://${BONDS_SUBGRAPH_URL[chainId]}`;
    const result = await requestPaged({
        chainId,
        url,
        query: BondMarketsQuery,
        variables,
        options,
    });
    return result.markets.map((market) => {
        const quoteToken = convertIdToMultichainId(copyIdToAddress(addChainId(chainId, market.quoteToken)));
        const payoutToken = convertIdToMultichainId(copyIdToAddress(addChainId(chainId, market.payoutToken)));
        return {
            ...market,
            quoteToken,
            payoutToken,
        };
    });
}
